<template>
  <h3 class="font-semibold text-gray-700 text-xl">{{ title }}</h3>
  <div id="chart4">
    <apexchart
      height="350"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "AELiquidationsQueryByProviderShowProviderLiquidationWeekly",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    data: { required: true },
    title: { default: '' },
    y_label: { default: '' },
    crop_size_labels: { required: true },
    formatter: { required: true }
  },
  data() {},
  computed: {
    series() {
      return [
        {
          name: "Kilos Exportados",
          data: this.data_ok,
          type: 'bar'
        },
        {
          name: "Ganancia/Kg Promedio",
          data: this.data_weekly,
          type: 'line'
        },
        ...this.crop_sizes,
      ];
    },
    options() {
      return {
        chart: {
          type: "line",
          height: 350,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        stroke: {
          width: [0, 4]
        },
        dataLabels: {
          enabled: true,
          enabledOnSeries: [1],
          formatter: function (val) {
            return this.numberWithPrecision(val, 2);
          }.bind(this)
        },
        markers: {
          size: 0,
          style: "hollow"
        },
        xaxis: {
          tickPlacement: "between",
          group: {
            groups: this.groups,
            style: {
              fontSize: "14px",
              fontWeight: 500
            }
          }
        },
          yaxis: [
            {
              title: { text: "Kilogramos" },
              show: true,
              labels: {
                formatter: function (val) {
                  return this.numberWithPrecision(val, 2);
                }.bind(this)
              }
            },
            ...Array(this.crop_size_labels.length + 1).fill({
              title: { text: this.y_label },
              show: false,
              opposite: true,
              labels: {
                formatter: function (val) {
                  if (!Number(val)) return;
                  return `$${this.numberWithPrecision(val, 2)}`;
                }.bind(this)
              }
            }),
          ],
          tooltip: {
          x: {
            formatter: function (val) {
              return `Sem ${val}`;
            }
          }
        },
        colors: [
          "#65A30D",
          "#3b82f6",
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#a855f7",
          "#f43f5e",
          "#eab308",
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      };
    },
    data_ok() {
      return Object.values(this.data)
        .flat()
        .map(data => {
          return {
            x: `${data.week}`,
            y: data.ok
          };
        });
    },
    data_weekly() {
      return Object.values(this.data)
        .flat()
        .map(data => {
          return {
            x: `${data.week}`,
            y: data.average_earning_per_kg
          };
        });
    },
    crop_sizes() {
      return this.crop_size_labels.map(label => {
        return {
          name: label,
          data: this.cropSizeData(label),
          type: 'line'
        }
      });
    },
    flat_data() {
      return Object.values(this.data).flat()
    },
    groups() {
      return Object.keys(this.data).map(key => {
        return {
          title: key,
          cols: this.data[key].length
        };
      });
    }
  },
  methods: {
    cropSizeData: function (label) {
      let data = []
      // Object.values(this.data).flat()
      //   .map(data => {
      //     return {
      //       x: `${data.week}`,
      //       y: data.average_earning_per_kg_by_crop_size[label],
      //     }
      //   });

      for (const [month, month_data] of Object.entries(this.data)) {
        month_data.forEach(week_data => {
          data.push({
            x: `${week_data.week}`,
            y: week_data.average_earning_per_kg_by_crop_size[label] || null,
            week_data: week_data,
            month: month
          })
        })
      }

      return data;
    }
  }
};
</script>
